import styled, { css } from 'styled-components';
import { getMargins, SEM_TYPOGRAPHY_ACTION_SM_LABEL, SYS_SPACE_FIXED_100, getTypographyStyles, SYS_SIZE_FIXED_1200, SYS_SIZE_FIXED_1400, SYS_BORDER_RADIUS_MAX, SEM_TYPOGRAPHY_ACTION_XS_LABEL, SEM_TYPOGRAPHY_ACTION_MD_LABEL, SYS_SIZE_FIXED_900 } from '@oneaudi/unified-web-alpha-common';
export const StyledIconButtonLabel = styled.span `
  ${(props) => getTypographyStyles(props.size === 'xs'
    ? SEM_TYPOGRAPHY_ACTION_XS_LABEL
    : props.size === 'sm'
        ? SEM_TYPOGRAPHY_ACTION_SM_LABEL
        : SEM_TYPOGRAPHY_ACTION_MD_LABEL)};
  text-align: center;
  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color;
`;
export const StyledIconButton = styled.button `
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  border-radius: ${SYS_BORDER_RADIUS_MAX};
  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, box-shadow, border-color, background;

  svg {
    flex-shrink: 0;
  }

  ${(props) => {
    if (props.disabled && !props.isLoading) {
        return css `
        cursor: not-allowed;
      `;
    }
    if (props.isLoading) {
        return css `
        cursor: progress;
      `;
    }
    return css `
      cursor: pointer;
    `;
}}

  ${(props) => props.as === 'a' &&
    css `
      box-sizing: border-box;
    `}

  ${(props) => props.size === 'md'
    ? css `
          width: ${SYS_SIZE_FIXED_1400};
          height: ${SYS_SIZE_FIXED_1400};
        `
    : props.size === 'sm'
        ? css `
            width: ${SYS_SIZE_FIXED_1200};
            height: ${SYS_SIZE_FIXED_1200};
          `
        : css `
            width: ${SYS_SIZE_FIXED_900};
            height: ${SYS_SIZE_FIXED_900};
          `}

    ${(props) => props.variant === 'primary' &&
    css `
      background: ${props.theme.sem.color.action.primary.surface.fill.default};
      color: ${props.theme.sem.color.action.primary.foreground.icon.default};
      border: 1px solid
        ${props.theme.sem.color.action.primary.surface.stroke.default};

      & + ${StyledIconButtonLabel} {
        color: ${(props) => props.theme.cmp.color.action.iconButton.primary.foreground.text
        .default};
      }
    `}

  ${(props) => props.variant === 'primary' &&
    props.as === 'button' &&
    !props.isLoading &&
    css `
      &:disabled {
        background: ${(props) => props.theme.sem.color.action.primary.surface.fill.disabled};
        color: ${props.theme.sem.color.action.primary.foreground.icon.disabled};

        & + ${StyledIconButtonLabel} {
          color: ${(props) => props.theme.cmp.color.action.iconButton.primary.foreground.text
        .disabled};
        }
      }
    `}

  ${(props) => props.variant === 'secondary' &&
    css `
      background: ${(props) => props.theme.sem.color.action.secondary.surface.fill.default};
      color: ${props.theme.sem.color.action.secondary.foreground.icon.default};
      border: 1px solid
        ${props.isLoading
        ? 'transparent'
        : props.theme.sem.color.action.secondary.surface.stroke.default};

      & + ${StyledIconButtonLabel} {
        color: ${(props) => props.theme.cmp.color.action.iconButton.secondary.foreground.text
        .default};
      }

      ${props.as === 'button' &&
        !props.isLoading &&
        css `
        &:disabled {
          background: ${(props) => props.theme.sem.color.action.secondary.surface.fill.disabled};
          color: ${props.theme.sem.color.action.secondary.foreground.icon
            .disabled};
          border-color: ${props.theme.sem.color.action.secondary.surface.stroke
            .disabled};

          & + ${StyledIconButtonLabel} {
            color: ${(props) => props.theme.cmp.color.action.iconButton.secondary.foreground.text
            .disabled};
          }
        }
      `}
    `}

  ${(props) => props.variant === 'tertiary' &&
    css `
      background: ${(props) => props.theme.sem.color.action.tertiary.surface.fill.default};
      color: ${props.theme.sem.color.action.tertiary.foreground.icon.default};
      border: 1px solid
        ${props.theme.sem.color.action.tertiary.surface.stroke.default};

      & + ${StyledIconButtonLabel} {
        color: ${(props) => props.theme.cmp.color.action.iconButton.tertiary.foreground.text
        .default};
      }

      ${props.as === 'button' &&
        !props.isLoading &&
        css `
        &:disabled {
          background: ${(props) => props.theme.sem.color.action.tertiary.surface.fill.disabled};
          color: ${props.theme.sem.color.action.tertiary.foreground.icon
            .disabled};
          border: 1px solid
            ${props.theme.sem.color.action.tertiary.surface.stroke.disabled};

          & + ${StyledIconButtonLabel} {
            color: ${(props) => props.theme.cmp.color.action.iconButton.tertiary.foreground.text
            .disabled};
          }
        }
      `}
    `}
`;
export const StyledIconButtonContainer = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min-content;
  gap: ${SYS_SPACE_FIXED_100};

  ${(props) => props.variant === 'primary' &&
    !props.isLoading &&
    css `
      &:hover {
        & ${StyledIconButton}:not(:disabled) {
          color: ${props.theme.sem.color.action.primary.foreground.icon.hover};
          border-color: ${props.theme.sem.color.action.primary.surface.stroke
        .hover};
          background: ${props.theme.sem.color.action.primary.surface.fill
        .hover};

          + ${StyledIconButtonLabel} {
            color: ${(props) => props.theme.cmp.color.action.iconButton.primary.foreground.text
        .hover};
          }
        }
      }

      &:active {
        & ${StyledIconButton}:not(:disabled) {
          color: ${props.theme.sem.color.action.primary.foreground.icon
        .pressed};
          border-color: ${props.theme.sem.color.action.primary.surface.stroke
        .pressed};
          background: ${props.theme.sem.color.action.primary.surface.fill
        .pressed};

          + ${StyledIconButtonLabel} {
            color: ${(props) => props.theme.cmp.color.action.iconButton.primary.foreground.text
        .pressed};
          }
        }
      }
    `}

  ${(props) => props.variant === 'secondary' &&
    !props.isLoading &&
    css `
      &:hover {
        & ${StyledIconButton}:not(:disabled) {
          color: ${props.theme.sem.color.action.secondary.foreground.icon
        .hover};
          border-color: ${props.theme.sem.color.action.secondary.surface.stroke
        .hover};
          background: ${(props) => props.theme.sem.color.action.secondary.surface.fill.hover};

          + ${StyledIconButtonLabel} {
            color: ${(props) => props.theme.cmp.color.action.iconButton.secondary.foreground.text
        .hover};
          }
        }
      }

      &:active {
        & ${StyledIconButton}:not(:disabled) {
          color: ${props.theme.sem.color.action.secondary.foreground.icon
        .pressed};
          border-color: ${props.theme.sem.color.action.secondary.surface.stroke
        .pressed};
          background: ${(props) => props.theme.sem.color.action.secondary.surface.fill.pressed};

          + ${StyledIconButtonLabel} {
            color: ${(props) => props.theme.cmp.color.action.iconButton.secondary.foreground.text
        .pressed};
          }
        }
      }
    `};

  ${(props) => props.variant === 'tertiary' &&
    !props.isLoading &&
    css `
      &:hover {
        & ${StyledIconButton}:not(:disabled) {
          color: ${props.theme.sem.color.action.tertiary.foreground.icon.hover};
          background: ${(props) => props.theme.sem.color.action.tertiary.surface.fill.hover};
          border-color: ${props.theme.sem.color.action.tertiary.surface.stroke
        .hover};

          + ${StyledIconButtonLabel} {
            color: ${(props) => props.theme.cmp.color.action.iconButton.tertiary.foreground.text
        .hover};
          }
        }
      }

      &:active {
        & ${StyledIconButton}:not(:disabled) {
          color: ${props.theme.sem.color.action.tertiary.foreground.icon
        .pressed};
          background: ${(props) => props.theme.sem.color.action.tertiary.surface.fill.pressed};
          border-color: ${props.theme.sem.color.action.tertiary.surface.stroke
        .pressed};
        }

        + ${StyledIconButtonLabel} {
          color: ${(props) => props.theme.cmp.color.action.iconButton.tertiary.foreground.text
        .pressed};
        }
      }
    `}
`;
//# sourceMappingURL=index.styles.js.map